import axios from "axios";

// Common

export const getLocations = query => axios.get(`/api/v1/common/locations/countries${query ? `?query=${query}` : ""}`);

export const getTowns = term => axios.get(`/api/v1/browse/towns${term ? `?term=${term}` : ""}`);

export const getCompanies = term => axios.get(`/api/v1/browse/companies${term ? `?term=${term}` : ""}`);

export const pingServer = () => axios.get("/api/v1/browse/ping");

export const getCountries = (notDefault = false, unordered = false) => {
  const params = new URLSearchParams();

  if (notDefault) {
    params.append("non_default", "true");
  }

  if (unordered) {
    params.append("unordered", "true");
  }

  const queryString = params.toString();
  return axios.get(`/api/v1/browse/countries${queryString ? `?${queryString}` : ""}`);
};
